export default function ConsultationScheduled() {
  return (
    <div className="min-h-screen bg-[#fffcef] px-4 flex items-start justify-center pt-8 pb-16">
      {/* Main dark green card */}
      <div className="bg-[#214d3c] rounded-2xl p-6 w-full max-w-[556px] flex flex-col gap-3">
        {/* Image */}
        <div className="w-full rounded-xl overflow-hidden">
          <img
            src="/progress.png"
            alt="Consultation scheduled"
            className="w-full h-64 object-cover rounded-xl"
          />
        </div>

        {/* Title */}
        <h1 className="text-[42px] leading-[44px] font-normal text-[#fef6d6] text-center font-recoleta tracking-[-0.588px] mt-2">
          Consultation Being Scheduled
        </h1>

        {/* Info box - cream background */}
        <div className="bg-[#fef6d6] border border-[rgba(48,64,49,0.3)] rounded-2xl p-6 flex flex-col items-center gap-2">
          {/* Icon */}
          <img
            src="/icon.svg"
            alt=""
            className="w-6 h-6"
            style={{ filter: 'brightness(0) saturate(100%) invert(18%) sepia(15%) saturate(1000%) hue-rotate(70deg) brightness(95%) contrast(90%)' }}
          />

          <p className="text-xl font-bold text-[#304031] text-center leading-[1.6]">
            We'd love to learn more about you.
          </p>

          <p className="text-sm text-[#304031] text-center leading-[1.4]">
            Our team is reviewing your application to ensure you align with the community standards we uphold across the Collective.
          </p>
        </div>

        {/* What happens next box - outlined */}
        <div className="border border-[#fffcef] rounded-2xl p-6">
          <p className="text-xl font-bold text-[#fef6d6] leading-[1.6] mb-3">
            Consultation scheduled
          </p>

          <p className="text-sm text-[#fef6d6] leading-[1.4]">
            A member of our Guide Collective team will reach out within 48 hours to coordinate your onboarding consultation and next steps.
          </p>
        </div>

        {/* Questions text */}
        <p className="text-sm text-[#fef6d6] text-center leading-[1.4]">
          Questions about the review process?
        </p>

        {/* Email Support button */}
        <div className="flex justify-center">
          <a
            href="mailto:support@guidescollective.com"
            className="inline-flex items-center gap-2 px-5 py-4 border border-[#fef6d6] rounded-full text-[#fef6d6] hover:bg-[#fef6d6]/10 transition-colors"
          >
            Email Support
          </a>
        </div>
      </div>
    </div>
  );
}
